import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, NgForm, FormBuilder } from '@angular/forms';
import { PayoutService } from 'src/app/services/payout.service';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { Router, ActivatedRoute } from '@angular/router';

const swal = require('sweetalert');

@Component({
  selector: 'app-payout-post-backurl',
  templateUrl: './payout-post-backurl.component.html',
  styleUrls: ['./payout-post-backurl.component.scss']
})
export class PayoutPostBackurlComponent implements OnInit {
  Editpostbackurl:boolean=false;
  isPayOutPostBackUrlHidden:boolean=true;
  isPayOutPostBackAuthKeyHidden:boolean=true;
  isimgHidden:boolean;
  viewdetail:boolean=true;
  Addata:boolean=false;
  content;
  PostBackUrl:any;
  AuthKey:any;
  merchantKeyId:any;
  mid:any;
  PayOutPostBackAuthKey=new FormControl('', []);
  PayOutPostBackUrl=new FormControl('', [Validators.required,Validators.pattern("(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?")]);

  constructor(private service: PayoutService, private commonfunction: CommonFunctionService, private router: Router) { 
    this.merchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.service.getMerchantSettingsById(this.merchantKeyId).subscribe(result => {
      this.content = result[0];
      if (this.content != null) {
        this.PostBackUrl=result[0].PayoutPostBackUrl;
        this.AuthKey=result[0].PayoutPostBackAuthKey;
        this.mid=result.MerchantKeyId;
        this.viewdetail=true;
        this.Addata=false;
      }
      else{
        this.viewdetail=false;;
        this.Addata=true;
      }
    });
  }

  ngOnInit() {
    this.getUserPermissions();
  }
  Updatedetails()
  {
    this.viewdetail=false;;
    this.Addata=true;
  }
  savepostbackurl() {
    let form = {
      MerchantKeyId: 0,
      PayoutPostBackUrl: "",
      PayoutPostBackAuthKey: "",
      LoginUserId:''

    }
    this.merchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    form.MerchantKeyId = this.merchantKeyId ;
    form.PayoutPostBackUrl = this.PayOutPostBackUrl.value;
    form.PayoutPostBackAuthKey = this.PayOutPostBackAuthKey.value;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.savepayoutpostback(form).subscribe(result => {
      if(result!=null)
      {
        // window.location.reload();
        this.openConfirmationDialog();
      }
    });
}


PayOutPostBackUrlerrors()
{
  return this.PayOutPostBackUrl.hasError("required")
  ? "PayOut PostBack Url is required"
  : this.PayOutPostBackUrl.hasError("pattern") ? "Enter valid PayOut PostBack Url" 
   :"";
}


openConfirmationDialog() {
    
  swal({
    title: 'PayOut PostBack Url Added Successfully',
    text: '',
    icon: 'success',
    buttons: {
      
        confirm: {
            text: 'Ok',
            value: true,
            visible: true,
            className: "",
            closeModal: true
        }
    }
}).then((isConfirm) => {
    if (isConfirm) {
    window.location.reload();
    }
  
});

}


getUserPermissions() {
  const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
    if (result != null) {
      for (var i in result) {
        if (result[i].UserPermission == 'PayOut') {
          var type = result[i].Type;
          if (type == 'R') 
          {
              this.Editpostbackurl=false;
          }
         else if (type == 'RW') 
          {
            this.Editpostbackurl=true;
          }
         else if (type == 'RWD') 
          {
            this.Editpostbackurl=true;
          }
        }
      }

    }

  });
}
redirecttoreportswebhookdata()
{
  this.router.navigate(['/PayOut/Payoutwebhookdata']);
}
}
